export default __webpack_public_path__ + "static/media/icon_red_hospitalaria_off.3031c8a1.svg";